export default __webpack_public_path__ + "static/media/about-vid-3.0c0f1f69.mp4";